var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-center"},[_c('div',[_c('Loader'),_c('h4',{staticClass:"text-center"},[_vm._v(" We are processing your application, please do not hit back or refresh your browser. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }